import queryString from 'query-string'

export default function getQueryParamsFromStringObjectUtil (queryStr = '') {
  return queryString.parse(queryStr) || {}
}
